// 利用axios请求数据文件

// 引入封装的axios文件(将请求方式替换为axios)
import request from "../tools/axios.js";

// get请求示例
// axios
//     .get(url, {
//         params: {
//             要发送的数据名: 数据,
//         },
//     })
//     .then(data => {})

// post请求示例(params没有大括号)
// axios
//     .post(url, {
//         // 要发送的数据名:数据
//     })
//     .then(data => {})

// 请求发送短信验证码的封装
// export function sendCode(params) {
//   return request.post("sms/sendSms", params);
// }

// // 请求注册用户的封装(表单用post来请求,发送的是一个对象)
// export function register(params) {
//   return request.post("/user/register", params);
// }

// // 请求登录用户的封装
// export function login(params) {
//   return request.post("/user/login", params);
// }

// 韵阁

// footer
export function footer(params) {
  return request.get("common/concat", {
    params,
  });
}

// 产品介绍(banner)
export function goodsBanner(params) {
  return request.get("goods/getCate", {
    params,
  });
}

// 产品介绍(子系列)
export function getGoodsTitleByCateId(params) {
  return request.get("goods/getGoodsTitleByCateId", {
    params,
  });
}
// 产品介绍(子系列的详细介绍)
export function getGoodsByGoodsId(params) {
  return request.get("goods/getGoodsByGoodsId", {
    params,
  });
}
// 专业定制(韵阁优势)
export function advantage(params) {
  return request.get("Customized/advantage", {
    params,
  });
}

// 专业定制(产品性能)
export function performance(params) {
  return request.get("Customized/performance", {
    params,
  });
}

// 专业定制(原材)
export function material(params) {
  return request.get("Customized/material", {
    params,
  });
}

// 专业定制(车间风貌)
export function workshop(params) {
  return request.get("Customized/workshop", {
    params,
  });
}

// 服务介绍(售后服务)
export function after(params) {
  return request.get("Service/after", {
    params,
  });
}
// 服务介绍(特色服务)
export function feature(params) {
  return request.get("Service/feature", {
    params,
  });
}
// 服务介绍(购买流程)
export function buy(params) {
  return request.get("Service/buy", {
    params,
  });
}

// 服务介绍(购买流程)
export function buyDesc(params) {
  return request.get("service/buy_desc", {
    params,
  });
}
// 韵阁案例(列表上方的数据)
export function casesIndex(params) {
  return request.get("Cases/index", {
    params,
  });
}
// 韵阁案例(列表图片)
export function cases(params) {
  return request.get("Cases/cases", {
    params,
  });
}
// 韵阁案例(列表图详情)
export function casesDetail(params) {
  return request.get("Cases/detail", {
    params,
  });
}

// 招商加盟(加盟案例)
export function attract(params) {
  return request.get("join/attract", {
    params,
  });
}
// 招商加盟(加盟案例上方文字)
export function attractText(params) {
  return request.get("join/attract_text", {
    params,
  });
}
// 招商加盟(加盟流程)
export function step(params) {
  return request.get("join/step", {
    params,
  });
}

export function stepBanner(params) {
  return request.get("/join/step_banner", {
    params,
  });
}

// 招商加盟(品牌支持banner)
export function supportBanner(params) {
  return request.get("join/support_banner", {
    params,
  });
}
// 招商加盟(品牌支持列表)
export function supportList(params) {
  return request.get("/join/support", {
    params,
  });
}
// 联系我们(联系我们)
export function concatUs(params) {
  return request.get("concat/us", {
    params,
  });
}
// 联系我们(全国门店)
export function concatStore(params) {
  return request.get("concat/store", {
    params,
  });
}

// 阁韵动态(列表)
export function newsList(params) {
  return request.get("news/index", {
    params,
  });
}

// 阁韵动态(列表进入详情)
export function newsDetail(params) {
  return request.get("news/detail", {
    params,
  });
}

// 企业文化
export function aboutCulture(params) {
  return request.get("about/Culture", {
    params,
  });
}
// 技术成就
export function aboutDevelopment(params) {
  return request.get("about/development", {
    params,
  });
}
// 阁韵简介
export function aboutIntroduce(params) {
  return request.get("about/introduce", {
    params,
  });
}
// 首页
export function index(params) {
  return request.get("index/index", {
    params,
  });
}

// :style="{
//   'background-image': `url(${contact_tel_bg_image})`,
// }"

// :style="
//         active == index
//           ? {
//               'background-image': `url(${item.bg_image})`,
//             }
//           : null
//       "
